import React, { useState, useEffect } from 'react'
import useStateRef from 'react-usestateref';
import Select from 'react-select';

import { Row, Col, Image, Form, Button, ListGroup, Modal } from 'react-bootstrap'
import { Link, json, useNavigate } from 'react-router-dom'
import Card from '../components/Card'
import axios from 'axios';
import config from "../config/config";
import apiPath from "../config/apipath";
import apiService from "../provider/apiService";
import 'bootstrap/dist/css/bootstrap.min.css';
import swal from 'sweetalert';
// img
import auth1 from '../assets/images/auth/01.png'
export default function SignIn() {
   const navigate = useNavigate();
   const [show1, setShow1] = useState(false);
   const handleClose1 = () => setShow1(false);
   const [BranchList, setBranchList]=useState([]);
   const [FinYearList, setFinYearList]=useState([]);
  
   const [FinYear,setFinYear,FinYearRef]=useStateRef("");
   const [Branch,setBranch,BranchRef]=useStateRef("");
   const [Email,setEmail,EmailRef]=useStateRef("");
   const [Password,setPassword,PasswordRef]=useStateRef("");
  
   useEffect(() => {
      GetBranch();
   }, []);

async function GetBranch()
{

   const results = await apiService.getCall(apiPath.master.get.getBranch);
   
 if (results!=undefined)
 {
   setBranchList(results.data[0]);
   


   if(results.data[0].length>0)
     setBranch(results.data[0][0].value);


   GetFinYear();

}  
  
}
async function GetFinYear()
{


   let postData = {
      BranchName: BranchRef.current,
  }

 
   const results = await apiService.postCall(apiPath.master.get.getFinYear,postData);

   if (results!=undefined)
   {
   setFinYearList(results.data[0]);
      
   if(results.data[0].length>0)
     setFinYear(results.data[0][0].value);
   }

}



   const navigateToSignIn = () => {
      try {
         let email = EmailRef.current;
         let password = PasswordRef.current;
         let branchname = BranchRef.current;
         let finyear = FinYearRef.current;
       
         var logindata = {
            "email": email,
            "password": password,
            "branch" : branchname,
            "finyear": finyear
         }

       
         axios({
            method: "post",
            url: config.apiEndPoint + apiPath.master.login, data: logindata,
         }).then((response) => {
           
            if (response.data.data[0].length == 0) {
               
               swal({

                  title: "Access Denied",
                  text: "Please check your username and password. ",
                  icon: "error",
                  button: "Ok"
                  
                }).then(function () {
                  
                });
               const getUrl = (e) => {
                  document.getElementById("menu_title").innerHTML = e;
               }


            } else {
               console.log("Else Check")
              sessionStorage.setItem("EntryUser",response.data.data[0][0].user_name);
              sessionStorage.setItem("FinMinDate",response.data.data[0][0].FinMinDate);
              sessionStorage.setItem("FinMaxDate",response.data.data[0][0].FinMaxDate);
              sessionStorage.setItem("BranchCode",response.data.data[0][0].BranchCode);
              sessionStorage.setItem("BranchName",response.data.data[0][0].BranchName);
              sessionStorage.setItem("FinYear",response.data.data[0][0].FinYear);
              sessionStorage.setItem("GroupId",response.data.data[0][0].GroupId);
              sessionStorage.setItem("GroupName",response.data.data[0][0].GroupName);

            
               navigate('/dashboard');
            }
         });
      } catch (error) {
         console.log(error);
      }


   };
   return (
      <>
         <section className="login-content">
            <Row className="m-0 align-items-center bg-white vh-100">
               <Col md="6">
                  <Row className="justify-content-center">
                     <Col md="10">
                        <Card className="card-transparent shadow-none d-flex justify-content-center mb-0 auth-card">
                           <Card.Body>
                              <Link to="/dashboard" className="navbar-brand d-flex align-items-center mb-3">
                                 <svg width="30" className="text-primary" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="-0.757324" y="19.2427" width="28" height="4" rx="2" transform="rotate(-45 -0.757324 19.2427)" fill="currentColor" />
                                    <rect x="7.72803" y="27.728" width="28" height="4" rx="2" transform="rotate(-45 7.72803 27.728)" fill="currentColor" />
                                    <rect x="10.5366" y="16.3945" width="16" height="4" rx="2" transform="rotate(45 10.5366 16.3945)" fill="currentColor" />
                                    <rect x="10.5562" y="-0.556152" width="28" height="4" rx="2" transform="rotate(45 10.5562 -0.556152)" fill="currentColor" />
                                 </svg>
                                 <h4 className="logo-title ms-3">AURA KANAK</h4>
                              </Link>
                              <h2 className="mb-2 text-center">Sign In</h2>
                              <p className="text-center">Login to stay connected.</p>
                              <Form>
                                 <Row>
                                    <Col lg="12">
                                       {/* <Form.Group className="form-group">
                                          <Form.Label htmlFor="exampleFormControlSelect1">Company</Form.Label>
                                          <select className="form-select" id="exampleFormControlSelect1">
                                             <option>Select Company</option>
                                             <option>GRT</option>
                                             <option>Sri Kumaran</option>

                                          </select>
                                       </Form.Group> */}
                                    </Col>
                                    
                                    <Col lg="6">
                                       
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="email" className="">Branch</Form.Label>
                                          <Select isSearchable={true} 
                                          value={BranchList.filter(function(option) {
                                             return option.value === Branch;
                                           })}

                                          options={BranchList}
                                          className="" 
                                          id="txtBranch"  
                                          onChange=
                                          {
                                             

                                             (e) => {

                                                setBranch(e.value);
                                                GetFinYear();
                                               
                                             }
                                             } >
                                            
							                        </Select>
                                   
                                       </Form.Group >
                                    </Col>

                                    <Col lg="6">
                                       
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="email" className="">Fin Year</Form.Label>
                                          <Select isSearchable={true} 
                                          options={FinYearList} className="" 
                                          value={FinYearList.filter(function(option) {
                                             return option.value === FinYear;
                                           })}
                                       onChange={(e)=>setFinYear(e.value)} id="txtFinYear"  >
                                             
							                        </Select>
                                       </Form.Group >
                                    </Col>


                                    <Col lg="12">
                                       
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="email" className="">User Id</Form.Label>
                                          <Form.Control type="email" value={Email} onChange={(e)=>setEmail(e.target.value)} autoComplete='false' className="" id="email" aria-describedby="email" placeholder=" " />
                                       </Form.Group >
                                    </Col>
                                    <Col lg="12" className="">
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="password" className="">Password</Form.Label>
                                          <Form.Control type="password" value={Password} onChange={(e)=>setPassword(e.target.value)} className="" id="password" aria-describedby="password" placeholder=" " />
                                       </Form.Group>
                                    </Col>
                                    {/* <Col lg="12" className="d-flex justify-content-between">
                                       <Form.Check className="form-check mb-3">
                                          <Form.Check.Input type="checkbox" id="customCheck1" />
                                          <Form.Check.Label htmlFor="customCheck1">Remember Me</Form.Check.Label>
                                       </Form.Check>
                                       <Link to="/auth/recoverpw">Forgot Password?</Link>
                                    </Col> */}
                                 </Row>
                                 <div className="d-flex justify-content-center">
                                    <Button onClick={navigateToSignIn} type="button" variant="btn btn-primary">Sign In</Button>
                                 </div>
                                 {/* <p className="text-center my-3">or sign in with other accounts?</p>
                                 <div className="d-flex justify-content-center">
                                    <ListGroup as="ul" className="list-group-horizontal list-group-flush">
                                       <ListGroup.Item as="li" className="border-0 pb-0">
                                          <Link to="#"><Image src={facebook} alt="fb" /></Link>
                                       </ListGroup.Item>
                                       <ListGroup.Item as="li" className="border-0 pb-0">
                                          <Link to="#"><Image src={google} alt="gm" /></Link>
                                       </ListGroup.Item>
                                       <ListGroup.Item as="li" className="border-0 pb-0">
                                          <Link to="#"><Image src={instagram} alt="im" /></Link>
                                       </ListGroup.Item>
                                       <ListGroup.Item as="li" className="border-0 pb-0">
                                          <Link to="#"><Image src={linkedin} alt="li" /></Link>
                                       </ListGroup.Item>
                                    </ListGroup>
                                 </div>
                                 <p className="mt-3 text-center">
                                    Don’t have an account? <Link to="/auth/sign-up" className="text-underline">Click here to sign up.</Link>
                                 </p> */}
                              </Form>
                           </Card.Body>
                        </Card>
                     </Col>
                  </Row>
                  <div className="sign-bg">
                     <svg width="280" height="230" viewBox="0 0 431 398" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.05">
                           <rect x="-157.085" y="193.773" width="543" height="77.5714" rx="38.7857" transform="rotate(-45 -157.085 193.773)" fill="#3B8AFF" />
                           <rect x="7.46875" y="358.327" width="543" height="77.5714" rx="38.7857" transform="rotate(-45 7.46875 358.327)" fill="#3B8AFF" />
                           <rect x="61.9355" y="138.545" width="310.286" height="77.5714" rx="38.7857" transform="rotate(45 61.9355 138.545)" fill="#3B8AFF" />
                           <rect x="62.3154" y="-190.173" width="543" height="77.5714" rx="38.7857" transform="rotate(45 62.3154 -190.173)" fill="#3B8AFF" />
                        </g>
                     </svg>
                  </div>
               </Col>
               <Col md="6" className="d-md-block d-none bg-primary p-0 mt-n1 vh-100 overflow-hidden">
                  <Image src={auth1} className="Image-fluid gradient-main animated-scaleX" alt="images" />
               </Col>
            </Row>
         </section>
      </>
   )
}

